var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form',{ref:_vm.refForm,class:_vm.formClass,attrs:{"id":_vm.markId,"model":_vm.model,"label-width":_vm.labelWidth,"rules":_vm.rules,"inline":_vm.inline,"size":_vm.size,"label-position":_vm.labelPosition}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }